module.exports = __webpack_public_path__ + "img/almaty2.22cf3f7a.jpg";